import React from 'react'
import injectSheet from 'react-jss'
import { NodeCrumbs } from '../../'
import {
  Check,
  Exclamation,
} from '../../icons/checkCircleIcons'

const CheckCircle = (props) => {
  const {
    classes,
    config,
    conflicts,
    requires,
  } = props

  const hasClash = ((conflicts && (conflicts.length > 0)) || (requires && (requires.length > 0)))

  return (
    <div className={`${classes.icon}`}>
      {hasClash ? (
        <div className={`${classes.clashContainer}`}>
          <Exclamation />
          <div
            role="button"
            tabIndex={0}
            onClick={e => e.stopPropagation()}
            onKeyDown={e => e.stopPropagation()}
            className={`${classes.clashTip}`}
          >
            <div>
              <h4>{config.title}</h4>
              <p>{config.intro}</p>
              {(requires && (requires.length > 0)) && (
                <div>
                  <p>{config.requires}</p>
                  <ul>
                    {requires.map(el => (el &&
                      <li key={`requires-${el.id}`}>
                        <NodeCrumbs
                          id={el.id}
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {(conflicts && (conflicts.length > 0)) && (
                <div>
                  <p>{config.conflicts}</p>
                  <ul>
                    {conflicts.map(el => (el &&
                      <li key={`conflicts-${el.id}`}>
                        <NodeCrumbs
                          id={el.id}
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <Check />
      )}
    </div>
  )
}

const styles = theme => ({
  icon: {
    width: '100%',
    height: '100%',
    '& svg': {
      position: 'absolute',
      top: 0,
      right: 0,
      fill: theme.colors.main_2,
    },
    '&:hover $clashTip': {
      opacity: 1,
      transition: [
        {
          property: 'opacity',
          duration: theme.speed.fast,
          delay: theme.speed.fast,
        },
      ],
    },
  },
  clashContainer: {
    position: 'relative',
    '& svg path': {
      fill: theme.colors.secondary_3c,
    },
    '& svg': {
      margin: '5px',
    },
  },
  clashTip: {
    width: '100%',
    height: '100%',
    overflow: 'scroll',
    color: theme.colors.secondary_3c,
    cursor: 'initial',
    zIndex: 1,
    opacity: 0,
    transition: [
      {
        property: 'opacity',
        duration: theme.speed.fast,
        delay: 0,
      },
    ],
    '& .button': {
      color: theme.colors.secondary_3b,
      '&:hover': {
        color: theme.colors.main_3,
      },
    },
  },
})

export default injectSheet(styles)(CheckCircle)



// WEBPACK FOOTER //
// ./src/modules/core/components/checkCircle.jsx